import middlewareConfig from "./middleware-config";
import { MIDDLEWARE_ENUMS } from "./middleware-constants";

const carCatalogGatewayApi = (api) => {

    const fetchOnDemandCitySearch = ({searchText}) => {
        return api.get(`api/v1/city?searchText=${searchText}`);
    };
    const fetchHeaderBuyCars = (cityId) => {
        return api.get(`/menu/hamburger/v1/${cityId}`);
    };
    const getPopularCityListAndBrands = () => {
        return api.get("website/v1/cities", {});
    };
    const getPresetFilters = (params) => {
        return api.get(`filter/v1/preset-filters`, { params });
    };

    return {
        fetchOnDemandCitySearch,
        fetchHeaderBuyCars,
        getPopularCityListAndBrands,
        getPresetFilters
    };
};

export const CarCatalogGatewayService = carCatalogGatewayApi(middlewareConfig(MIDDLEWARE_ENUMS.CAR_CATALOG_GATEWAY));
